<template>
  <el-cascader
    ref="cascader"
    :value="value"
    :options="options"
    :disabled="disabled"
    :props="{multiple:true}"
    filterable
    clearable
    separator="-"
    placeholder=" "
    class="container-load-type-cascader"
    @input="val=>{$emit('input',val)}"
    @visible-change="onVisibleChange"
  />
</template>

<script>
import {
  CONTAINERLOAD_TYPES,
  IE_TYPES,
  OPERATE_TYPES,
  STUFFY_CL,
  STUFFY_IC,
  STUFFY_TT
} from '@/class/cargo/model/parameters/ContainerLoadType'
import { BUSINESS_MODELS } from '@/class/cargo/model/parameters/AirExportConstants'
import { _cargoTypeInputList } from '@/class/cargo/model/parameters/ImportConstants'

export default {
  name: 'ContainerLoadTypeCascader',
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    allLob: { type: Boolean, default: false }
  },
  data() {
    return {
      options: [],
      isEdit: false // 是否正在编辑
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    value() {
      this.toCustomDisplay()
    }
  },
  created() {
    /* 海出 */
    const seOptions = {
      value: 'SE',
      label: this.allLob ? this.$t('CargoMsg.Cargo_FclLclTypeSeaExport') : this.$t('CargoMsg.Cargo_OceanExport'),
      children: []
    }
    for (const item of CONTAINERLOAD_TYPES) {
      seOptions.children.push({
        value: item.code,
        label: this.isZh ? item.chineseName : item.englishName
      })
    }

    /* 海进 */
    const siOptions = {
      value: 'SI',
      label: this.allLob ? this.$t('CargoMsg.Cargo_FclLclTypeSeaImport') : this.$t('CargoMsg.Cargo_OceanImport'),
      children: []
    }
    for (const item of _cargoTypeInputList) {
      siOptions.children.push({
        value: item.code,
        label: this.isZh ? item.chineseName : item.englishName
      })
    }

    if (!this.allLob) {
      /* 铁出 */
      const reOptions = {
        value: 'RE',
        label: this.$t('CargoMsg.Cargo_RailwayExport'),
        children: seOptions.children // 同海出
      }
      /* 铁进 */
      const riOptions = {
        value: 'RI',
        label: this.$t('CargoMsg.Cargo_RailwayImport'),
        children: seOptions.children // 同海出
      }
      this.options = [seOptions, siOptions, reOptions, riOptions]
    } else {
      /* 空出 */
      const aeOptions = {
        value: 'AE',
        label: this.$t('CargoMsg.Cargo_OperationModeAirExport'),
        children: []
      }
      for (const item of BUSINESS_MODELS) {
        aeOptions.children.push({
          value: item.code,
          label: this.isZh ? item.chineseName : item.englishName
        })
      }

      /* 空进 */
      const aiOptions = {
        value: 'AI',
        label: this.$t('CargoMsg.Cargo_OperationModeAirImport'),
        children: aeOptions.children // 同空出
      }

      /* 铁路 */
      const reOptions = {
        value: 'RE',
        label: this.$t('CargoMsg.Cargo_ContainerLoadTypeRailWay'),
        children: seOptions.children // 同海出
      }

      /* 综合物流 */
      const icChildrens = []
      for (const item of OPERATE_TYPES) {
        icChildrens.push({
          value: item.code,
          label: this.isZh ? item.chineseName : item.englishName
        })
      }
      const ieChildrens = [{ value: STUFFY_TT.code, label: this.isZh ? STUFFY_TT.chineseName : STUFFY_TT.englishName },
        { value: STUFFY_CL.code, label: this.isZh ? STUFFY_CL.chineseName : STUFFY_CL.englishName },
        { value: STUFFY_IC.code, label: this.isZh ? STUFFY_IC.chineseName : STUFFY_IC.englishName, children: icChildrens }]
      const ieOptions = {
        value: 'IE',
        label: this.$t('CargoMsg.Cargo_OrderType'),
        children: ieChildrens
      }

      this.options = [seOptions, siOptions, aeOptions, aiOptions, reOptions, ieOptions]
    }
  },
  mounted() {
    this.toCustomDisplay(false)
  },
  methods: {
    toCustomDisplay() {
      this.$nextTick(() => {
        const cascader = this.$refs.cascader
        if (!cascader) {
          return
        }
        const tags = cascader.$el.querySelector('.el-cascader__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let searchInput = null
        for (const child of tags.childNodes) {
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-cascader__search-input')) {
            searchInput = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (cascader.inputValue) {
            cascader.inputValue = cascader.inputValue.trim()
          }
          if (cascader.presentText) {
            cascader.presentText = cascader.presentText.trim()
          }
          if (searchInput) {
            searchInput.style.display = ''
            if (searchInput.value) {
              searchInput.value = searchInput.value.trim()
            }
            searchInput.setAttribute('placeholder', this.getDisplay())
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getDisplay()
          customDisplay.setAttribute('title', this.getDisplayTitle())
          if (searchInput) {
            searchInput.style.display = 'none'
          }
        }
      })
    },
    getDisplay() {
      const arr = []
      for (const [val1, val2, val3] of this.value) {
        const option = this.options.find(p => p.value === val1)
        if (!option) {
          continue
        }
        const subOption = option.children.find(p => p.value === val2)
        if (!subOption) {
          continue
        }
        let dataValue = option.label + '-' + subOption.label
        if (val3) {
          const sub3Option = subOption.children.find(p => p.value === val3)
          dataValue += '-' + sub3Option.label
        }
        arr.push(dataValue)
      }
      return arr.join('|')
    },
    getDisplayTitle() {
      let result = ''
      let count = 0
      for (const [val1, val2] of this.value) {
        const option = this.options.find(p => p.value === val1)
        if (!option) {
          continue
        }
        const subOption = option.children.find(p => p.value === val2)
        if (!subOption) {
          continue
        }
        if (result) {
          if (count % 2 === 0) {
            result += '\n'
          } else {
            result += ' '
          }
        }
        result += option.label + '-' + subOption.label
        count += 1
      }
      return result
    },
    onVisibleChange(e) {
      this.isEdit = e
      this.toCustomDisplay()
    }
  }
}
</script>

<style lang="scss">
.el-cascader.container-load-type-cascader {
  width: 100%;
  .el-cascader__tags {
    .custom-display {
      overflow: hidden;
      white-space: nowrap;
      padding-left: 15px;
    }
    .el-tag--info {
      display: none;
    }
  }
}
</style>
